// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.midnight-dialog {
  /* Use the highest possible z-index so this dialog can never be covered by other
     full-screen overlays (e.g. mobile sidebar/drawer overlays also using very high
     z-indexes such as 999999/1000000). */
  z-index: 2147483647 !important;
  position: fixed !important;
  inset: 0 !important;
}
.midnight-dialog .k-dialog {
  width: 480px;
  padding: 0;
  border-radius: 16px;
  overflow: hidden;
  border: none;
}

.midnight-card {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.midnight-image img {
  width: -webkit-fill-available;
}

.midnight-content {
  padding: 20px 30px;
  text-align: center;
}

.midnight-content h2 {
  margin: 0 0 12px 0;
  font-size: 18px;
  color: #000;
  font-weight: 600;
}

.midnight-content p {
  font-size: 14px;
  color: #666;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  text-align: left;
}

.midnight-footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  gap: 8px;
  padding: 20px 30px;
  border-top: 1px solid #dadada;
}

.midnight-footer .cancel-button {
  border-radius: 40px;
  border: 1px solid #dadada;
  background: #fff;
  color: #333;
  padding: 6px 12px;
  cursor: pointer;
}

.midnight-footer .confirm-button {
  border-radius: 40px;
  color: #fff;
  background: #333;
  padding: 6px 12px;
  border: none;
  cursor: pointer;
}

/* Mobile */
.mobile-midnight-dialog .k-dialog {
  width: 90% !important;
}


/* Mobile adjustments: title centered, paragraph left, footer buttons evenly split */
.mobile-midnight-dialog .midnight-content h2 {
  text-align: center;
}

.mobile-midnight-dialog .midnight-content p {
  text-align: left;
}

.mobile-midnight-dialog .midnight-footer {
  padding: 16px 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 8px;
}

.mobile-midnight-dialog .midnight-footer button {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  min-width: 0; /* allow flex to shrink */
}
`, "",{"version":3,"sources":["webpack://./src/css/MidnightClockingDialog.css"],"names":[],"mappings":"AAAA;EACE;;yCAEuC;EACvC,8BAA8B;EAC9B,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,qBAAqB;AACvB;;;AAGA,oFAAoF;AACpF;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAO;MAAP,WAAO;UAAP,OAAO;EACP,YAAY,EAAE,yBAAyB;AACzC","sourcesContent":[".midnight-dialog {\n  /* Use the highest possible z-index so this dialog can never be covered by other\n     full-screen overlays (e.g. mobile sidebar/drawer overlays also using very high\n     z-indexes such as 999999/1000000). */\n  z-index: 2147483647 !important;\n  position: fixed !important;\n  inset: 0 !important;\n}\n.midnight-dialog .k-dialog {\n  width: 480px;\n  padding: 0;\n  border-radius: 16px;\n  overflow: hidden;\n  border: none;\n}\n\n.midnight-card {\n  display: flex;\n  flex-direction: column;\n}\n\n.midnight-image img {\n  width: -webkit-fill-available;\n}\n\n.midnight-content {\n  padding: 20px 30px;\n  text-align: center;\n}\n\n.midnight-content h2 {\n  margin: 0 0 12px 0;\n  font-size: 18px;\n  color: #000;\n  font-weight: 600;\n}\n\n.midnight-content p {\n  font-size: 14px;\n  color: #666;\n  font-weight: 400;\n  line-height: 20px;\n  margin: 0;\n  text-align: left;\n}\n\n.midnight-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 20px 30px;\n  border-top: 1px solid #dadada;\n}\n\n.midnight-footer .cancel-button {\n  border-radius: 40px;\n  border: 1px solid #dadada;\n  background: #fff;\n  color: #333;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.midnight-footer .confirm-button {\n  border-radius: 40px;\n  color: #fff;\n  background: #333;\n  padding: 6px 12px;\n  border: none;\n  cursor: pointer;\n}\n\n/* Mobile */\n.mobile-midnight-dialog .k-dialog {\n  width: 90% !important;\n}\n\n\n/* Mobile adjustments: title centered, paragraph left, footer buttons evenly split */\n.mobile-midnight-dialog .midnight-content h2 {\n  text-align: center;\n}\n\n.mobile-midnight-dialog .midnight-content p {\n  text-align: left;\n}\n\n.mobile-midnight-dialog .midnight-footer {\n  padding: 16px 20px;\n  display: flex;\n  gap: 8px;\n}\n\n.mobile-midnight-dialog .midnight-footer button {\n  flex: 1;\n  min-width: 0; /* allow flex to shrink */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
